import React from 'react';
import Input from 'antd/lib/input/Input';
import { dummyFunc } from '../../utils/MiscUtils';
import styles from './FormInput.module.css';
import { Rule } from 'antd/es/form';
import FormItem from 'antd/lib/form/FormItem';
import FormItemLabel from 'antd/lib/form/FormItemLabel';

interface IFormInput {
  onChange?: (e: any) => any;
  onBlur?: (e: any) => any;
  id: string;
  labelText?: string;
  value?: string | number;
  validation?: any;
  warning?: any;
  type?: string;
  CustomInput?: any;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  allowClear?: boolean;
  useCustomStyles?: boolean;
  maxlength?: number;
  placeholder?: string;
  max?: number;
  min?: number;
  validationRules?: Array<Rule>;
  clientValidation?: boolean;
  hide?: boolean;
}

const FormInput: React.FC<IFormInput> = (props) => {
  const {
    onChange = dummyFunc,
    onBlur = dummyFunc,
    id,
    labelText,
    value = '',
    validation,
    type = 'text',
    CustomInput,
    required = false,
    disabled = false,
    warning,
    className,
    allowClear = false,
    useCustomStyles = false,
    maxlength,
    placeholder,
    max,
    min,
    validationRules,
    clientValidation,
    hide,
    ...rest
  } = props;

  let validateStatus: any;
  let help: React.ReactNode | undefined;

  if (validation) {
    validateStatus = 'error';
    if (typeof validation === 'string') {
      help = validation;
    }
  } else if (warning) {
    validateStatus = 'warning';
    help = warning;
  }

  return clientValidation ? (
    CustomInput && !hide ? (
      <FormItem className={className ? className : styles.wrapper} name={id} validateStatus={validateStatus} help={help}>
        <CustomInput />
      </FormItem>
    ) : !hide ? (
      <FormItem
        className={className ? className : styles.wrapper}
        label={labelText}
        validateStatus={validateStatus}
        help={help}
        name={id}
        rules={validationRules}
      >
        <Input
          id={id}
          type={type}
          value={value}
          placeholder={placeholder}
          allowClear={allowClear}
          suffix={<span />}
          onChange={onChange}
          onBlur={onBlur}
          required={required}
          disabled={disabled}
          className={useCustomStyles ? styles.input : ''}
          maxLength={maxlength}
          max={max}
          min={min}
          {...rest}
        />
      </FormItem>
    ) : (
      <></>
    )
  ) : (
    <FormItem className={className ? className : styles.wrapper} validateStatus={validateStatus} help={help}>
      {labelText && <FormItemLabel prefixCls={id} htmlFor={id} label={labelText} />}
      {CustomInput ? (
        <CustomInput />
      ) : (
        <Input
          id={id}
          type={type}
          value={value}
          placeholder={placeholder}
          allowClear={allowClear}
          suffix={<span />}
          onChange={onChange}
          onBlur={onBlur}
          required={required}
          disabled={disabled}
          className={useCustomStyles ? styles.input : ''}
          maxLength={maxlength}
          max={max}
          min={min}
          {...rest}
        />
      )}
    </FormItem>
  );
};

export default FormInput;
